import { Navigate, useOutletContext } from 'react-router-dom'

import type { CurrentPlayerCtx, Phase } from './PlayerShell'

/**
 * Phase-aware index redirect for `/s/:playerKey`. Sends the player to
 * the right primary tab based on derived phase — Bordet during poker,
 * Spill during golf. Without this, a SMS deep-link to the bare player
 * URL during poker phase would land on the (no-longer-primary) golf
 * score view.
 */
const IndexRedirect = () => {
  const { phase } = useOutletContext<{
    player: CurrentPlayerCtx
    phase: Phase
  }>()
  return <Navigate to={phase === 'POKER' ? 'poker' : 'score'} replace />
}

export default IndexRedirect
